import { Grid, InputLabel, Typography } from '@material-ui/core';
import { Select, TextInput } from '@room-match/shared-ui-components';
import { useStyles } from '../MissingInfoDialog.styles';
import AdultSlider from 'pages/MyInfo/GeneralAppearance/AdultSlider';
import MinorSlider from 'pages/MyInfo/GeneralAppearance/MinorSlider';
import gender from 'data/Gender.json';
import hairColour from 'data/HairColor.json';
import eyeColour from 'data/EyeColor.json';
import EthnicAppearances from 'data/EthnicAppearances.json';
import Nationalities from 'data/Nationalities.json';
import newweight from 'data/new/Weight.json';
import newheight from 'data/new/Height.json';
import minorheight from 'data/new/minorSizes/MinorHeight.json';
import unions from 'data/Unions.json';
import { ISpecificTalentResponsePayload } from 'shared/interfaces/ITalent';
import { Dispatch, SetStateAction } from 'react';

interface Props {
  talent: ISpecificTalentResponsePayload['data']['talent'];
  setTalent: Dispatch<SetStateAction<ISpecificTalentResponsePayload['data']['talent']>>;
  isMinor: boolean;
  metricValue: string;
  ageRangeVal: number[];
  setAgeRangeVal: Dispatch<SetStateAction<number[]>>;
  country: string;
  birth: {
    day: string;
    month: string;
    year: string;
  };
}

const StepOne: React.FC<Props> = ({
  talent,
  setTalent,
  ageRangeVal,
  setAgeRangeVal,
  isMinor,
  birth,
  metricValue,
  country,
}) => {
  const classes = useStyles();
  const heightOptions = (isMinor ? minorheight.concat(newheight) : newheight).map((i) =>
    metricValue === 'AL' ? i.im : metricValue === 'CM' ? i.metric : i.imperial,
  );

  const filteredHeightOptions: any[] = [];
  heightOptions.forEach((e) => {
    if (!filteredHeightOptions.includes(e)) {
      filteredHeightOptions.push(e);
    }
  });

  return (
    <div className={classes.missingInfos}>
      <Typography className={classes.missingInfoInstruction}>Please enter missing information</Typography>
      <Grid container spacing={2}>
        <Grid item lg={6} md={12} xs={12}>
          <Grid item lg={12} md={12} xs={12}>
            <InputLabel id="gender">Gender*</InputLabel>
            <Select
              variant="outlined"
              fullWidth
              data={gender}
              className={classes.select}
              placeHolder={'Select'}
              onChange={(e: any) => setTalent({ ...talent, gender: e.target.value })}
              name="gender"
              value={talent?.gender}
              errorMessage={!talent?.gender ? 'Please select your gender.' : ''}
            />
          </Grid>
          {country === 'us' && (
            <Grid item lg={12} md={12} xs={12}>
              <InputLabel id="gender">Union*</InputLabel>
              <Grid container spacing={1}>
                <Grid item lg={6} md={6} xs={12}>
                  <Select
                    variant="outlined"
                    fullWidth
                    data={unions}
                    className={classes.select}
                    placeHolder={'Select'}
                    onChange={(e: any) =>
                      setTalent({
                        ...talent,
                        unions: [{ name: e.target.value, id_number: talent?.unions[0]?.id_number }],
                      })
                    }
                    name="union"
                    value={talent?.unions[0]?.name}
                    errorMessage={!talent?.unions[0]?.name ? 'Please select union.' : ''}
                  />
                </Grid>
                <Grid item lg={6} md={6} xs={12}>
                  <TextInput
                    variant="outlined"
                    fullWidth
                    // className={classes.select}
                    onChange={(e: any) =>
                      setTalent({ ...talent, unions: [{ name: talent?.unions[0]?.name, id_number: e.target.value }] })
                    }
                    name="unionId"
                    value={talent?.unions[0]?.id_number}
                    // errorMessage={!talentGender ? 'Please select union.' : ''}
                  />
                </Grid>
              </Grid>
            </Grid>
          )}
          <Grid item lg={12} md={12} xs={12}>
            <InputLabel id="gender">Primary Ethnic Appearance*</InputLabel>
            <Select
              variant="outlined"
              fullWidth
              data={EthnicAppearances}
              className={classes.select}
              placeHolder={'Select'}
              onChange={(e: any) =>
                setTalent({ ...talent, general: { ...talent.general, ethnic_appearance_primary: e.target.value } })
              }
              name="ethnicity"
              value={talent?.general?.ethnic_appearance_primary}
              errorMessage={!talent?.general?.ethnic_appearance_primary ? 'Please select your ethnicity.' : ''}
            />
          </Grid>
          <Grid item lg={12} md={12} xs={12}>
            <InputLabel id="gender">Secondary Ethnic Appearance (if applicable)</InputLabel>
            <Select
              variant="outlined"
              fullWidth
              data={EthnicAppearances}
              className={classes.select}
              placeHolder={'Select'}
              onChange={(e: any) =>
                setTalent({ ...talent, general: { ...talent.general, ethnic_appearance_secondary: e.target.value } })
              }
              name="second_ethnicity"
              value={talent?.general?.ethnic_appearance_secondary}
            />
          </Grid>
          <Grid item lg={12} md={12} xs={12}>
            <InputLabel id="gender">Nationality*</InputLabel>
            <Select
              variant="outlined"
              fullWidth
              data={Nationalities}
              className={classes.select}
              placeHolder={'Select'}
              onChange={(e: any) =>
                setTalent({ ...talent, general: { ...talent.general, nationality: e.target.value } })
              }
              name="nationality"
              value={talent?.general?.nationality}
              errorMessage={!talent?.general?.nationality ? 'Please select your nationality.' : ''}
            />
          </Grid>
        </Grid>

        <Grid item lg={6} md={12} xs={12}>
          <Grid item lg={12} md={12} xs={12}>
            <InputLabel id="gender">Height*</InputLabel>
            <Select
              variant="outlined"
              fullWidth
              data={filteredHeightOptions.map((h) => ({ key: h, value: h }))}
              className={classes.select}
              placeHolder={'Select Height'}
              onChange={(e: any) =>
                setTalent({ ...talent, statistics: { ...talent.statistics, height: e.target.value } })
              }
              name="height"
              value={talent?.statistics?.height}
              errorMessage={!talent?.statistics?.height ? 'Please select your height.' : ''}
            />
          </Grid>

          {country === 'us' && (
            <Grid item lg={12} md={12} xs={12}>
              <InputLabel id="gender">Weight*</InputLabel>
              <Select
                variant="outlined"
                fullWidth
                data={newweight.map((i) =>
                  metricValue === 'AL'
                    ? {
                        key: i.im,
                        value: i.im,
                      }
                    : metricValue === 'CM'
                      ? {
                          key: i.metric,
                          value: i.metric,
                        }
                      : {
                          key: i.imperial,
                          value: i.imperial,
                        },
                )}
                className={classes.select}
                placeHolder={'Select Weight'}
                onChange={(e: any) =>
                  setTalent({ ...talent, statistics: { ...talent.statistics, weight: e.target.value } })
                }
                name="weight"
                value={talent?.statistics?.weight}
                errorMessage={!talent?.statistics?.weight ? 'Please select your weight.' : ''}
              />
            </Grid>
          )}

          <Grid item lg={12} md={12} xs={12}>
            <InputLabel id="gender">Hair Colour*</InputLabel>
            <Select
              variant="outlined"
              fullWidth
              data={hairColour.map((i) => ({
                key: i.value,
                value: i.value,
              }))}
              className={classes.select}
              placeHolder={'Select Hair Colour'}
              onChange={(e: any) =>
                setTalent({ ...talent, general: { ...talent.general, hair_colour: e.target.value } })
              }
              name="haircolour"
              value={talent?.general?.hair_colour}
              errorMessage={!talent?.general?.hair_colour ? 'Please select your hair colour.' : ''}
            />
          </Grid>

          <Grid item lg={12} md={12} xs={12}>
            <InputLabel id="gender">Eye Colour*</InputLabel>
            <Select
              variant="outlined"
              fullWidth
              data={eyeColour.map((i) => ({
                key: i.value,
                value: i.value,
              }))}
              className={classes.select}
              placeHolder={'Select Eye Colour'}
              onChange={(e: any) =>
                setTalent({ ...talent, general: { ...talent.general, eye_colour: e.target.value } })
              }
              name="eyecolour"
              value={talent?.general?.eye_colour}
              errorMessage={!talent?.general?.eye_colour ? 'Please select your eye colour.' : ''}
            />
          </Grid>
        </Grid>
        <Grid item lg={12} md={12} xs={12}>
          {isMinor ? (
            <MinorSlider birth={birth} val={ageRangeVal} setVal={setAgeRangeVal} />
          ) : (
            <AdultSlider val={ageRangeVal} setVal={setAgeRangeVal} keepRanged={true} />
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default StepOne;
